

//lodash
window._ = require('lodash');

// import * as Cookies from 'js-cookie';

//Cookies.set('utm',JSON.stringify({utm_source:11,utm_medium:'',utm_campaign:'',utm_content:'',utm_term:''}),{ expires: 365 })

//稿件可以访问
// if(window.location.pathname.indexOf("manuscripts")==-1)
// {

//     const authPage = ['/login','/signup','/retrievepwd'].indexOf(window.location.pathname)>-1;

// }

//目前只对一些媒体列表页做跳转
if(window.navigator.userAgent.match('Mobile'))
{   
    const url = window.location.origin+window.location.pathname

    const maps ={ 
        'https://i.711.cn/resource/woa':'https://m.711.cn/media?tab=woa',
        'https://i.711.cn/resource/video':'https://m.711.cn/media?tab=video',
        'https://i.711.cn/resource/xhs':'https://m.711.cn/media?tab=xhs',
        'https://i.711.cn/resource/weibo':'https://m.711.cn/media?tab=weibo',
        'https://i.711.cn/resource/live':'https://m.711.cn/media?tab=live',
    }

    if(maps.hasOwnProperty(url))
    {
        window.location.href=maps[url]
    }
}
